import { render } from "./CampaignCard.vue?vue&type=template&id=46f9d1af&scoped=true"
import script from "./CampaignCard.vue?vue&type=script&lang=js"
export * from "./CampaignCard.vue?vue&type=script&lang=js"

import "./CampaignCard.vue?vue&type=style&index=0&id=46f9d1af&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46f9d1af"]])

export default __exports__